const SERVICE_IDENTIFIER = {
    API_SERVICE: Symbol.for("ApiService"),
    API_SERVICE_EXT: Symbol.for("ApiServiceExt"),
    AUTH_SERVICE: Symbol.for("AuthService"),
    NOTIFY: Symbol.for("Notify"),
    MENU_SERVICE: Symbol.for("MenuService"),
    APPLAYOUT_SERVICE: Symbol.for("AppLayout"),

    LOCAL_STORAGE_SERVICE: Symbol.for("LocalStorageService"),
    SESSION_STORAGE_SERVICE: Symbol.for("SessionStorageService"),

    ACCOUNT_SERVICE: Symbol.for("AccountService"),
    UTILITY_SERVICE: Symbol.for("UtilityService"),
    STRESSTEST_SERVICE: Symbol.for("StresstestService"),
    CLIENTE_SERVICE: Symbol.for("ClienteService"),
    UTENTE_SERVICE: Symbol.for("UtenteService"),
    UTENTE_BACKOFFICE_SERVICE: Symbol.for("UtenteBackofficeService"),
    CLIENTE_ADMIN_SERVICE: Symbol.for("ClienteAdminService"),
    RACCOLTA_DATI_SERVICE: Symbol.for("RaccoltaDatiService"),
    CONFIGURAZIONE_SERVICE: Symbol.for("ConfigurazioneService"),
    YAPILY_SERVICE: Symbol.for("YapilyService"),
    SUPPORT_SERVICE: Symbol.for("SupportoService"),
    PIANO_PREVISIONALE: Symbol.for("PianoPrevisionaleService"),
    SIGNALR: Symbol.for("SignalR"),
    LICENZE_SERVICE: Symbol.for("LicenzeService"),
    LICENZA_CLIENTI_SERVICE: Symbol.for("LicenzaClientiService"),
}

export default SERVICE_IDENTIFIER